<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Small Barrel</h2>
        <!-- <h3></h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              src="contrology-smallbarrel-1@1x.jpg"
              src2="contrology-smallbarrel-1@2x.jpg"
              alt="Photo of Contrology Small Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-smallbarrel-2@1x.jpg"
              src2="contrology-smallbarrel-2@2x.jpg"
              alt="Angled photo of Contrology Small Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-smallbarrel-3@1x.jpg"
              src2="contrology-smallbarrel-3@2x.jpg"
              alt="In-use photo of Contrology Small Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="SmallBarrelVideoThumb@1x.jpg"
              src2="SmallBarrelVideoThumb@2x.jpg"
              alt="Video of Contrology Small Barrel"
              video
            />
          </photo-grid>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Small Barrel</h2>
              <!-- <h3></h3> -->
              <p>
                Ideal for Contrology Folding Mat work, the lower curve of the Contrology Small Barrel provides better positioning for smaller and less mobile clients, targeting lower abdominal and core muscles. Its gradual arc makes Barrel exercises accessible for those with limited flexibility in the back and neck.
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="14-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >10-Year Warranty</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Featuring Contrology's signature high-density foam that delivers maximum feedback</li>
              <li>Equipped with web straps for flexible hand support.</li>
              <li>Includes strap that tucks under the bottom to use as a handle in exercises like the leg series</li>
              <li>Durable frame with premium upholstery holds up to everyday use</li>
              <li>Compact design is easy to move and store</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>L: 22” (55.88 cm)</p>
            <p>W: 19.5” (49.53 cm)</p>
            <p>H: 7.5” (19.05 cm)</p>
            <p>Weight: 15lbs (6.8 kg)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Featuring Contrology's signature high-density foam that delivers maximum feedback</li>
                <li>Equipped with web straps for flexible hand support.</li>
                <li>Includes strap that tucks under the bottom to use as a handle in exercises like the leg series</li>
                <li>Durable frame with premium upholstery holds up to everyday use</li>
                <li>Compact design is easy to move and store</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p>L: 22” (55.88 cm)</p>
              <p>W: 19.5” (49.53 cm)</p>
              <p>H: 7.5” (19.05 cm)</p>
              <p>Weight: 15lbs (6.8 kg)</p>
            </tab>
          </tabs>
        </section>
      </div>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/Dq0_G9GoII8?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "smallbarrel",

  metaInfo: {
    title: "Contrology® Small Barrel",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Ideal for Contrology Folding Mat work, the lower curve of the Contrology Small Barrel provides better positioning for smaller and less mobile clients, targeting lower abdominal and core muscles."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    ProdAccordion,
    Tabs,
    Tab,
    Modal,
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Small Barrel",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 48896115671233,
          partnumber: 18953,
          price: 525,
          name: "Contrology Small Barrel",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 48896115704001,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 48896115736769,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 48896115769537,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 48896115802305,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 48896115835073,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 48896115867841,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 48896115900609,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 48896115933377,
          partnumber: "18953C",
          price: "525",
          name: "Contrology Small Barrel",
          color: "Wedgewood Upholstery",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
    initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 130%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 85%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
